import React from "react";
const Pageslide = ({ name,imgaes,className }) => {
  return (
    <>
      <div className="relative w-full ">
        <div className=" absolute inset-0 flex items-center justify-center  ">
          <p className=" font-roboto lg:text-7xl  text-4xl  text-stone-950  ">
            {name}
          </p>
        </div>
        <img
          src={imgaes}
          className={className}
        />
      </div>
    </>
  );
};

export default Pageslide;
